import { Loader2, Save, CheckCircle, AlertCircle } from 'lucide-react';

export type SaveStatus = 'idle' | 'success' | 'error';

export interface SettingsSaveBarProps {
  saving: boolean;
  status: SaveStatus;
  onSave: () => void;
  label?: string;
  successLabel?: string;
  errorLabel?: string;
  children?: React.ReactNode;
}

/**
 * Sticky save bar dla stron ustawień. Przycisk zapisu po lewej + inline status
 * (Zapisano / Błąd zapisu) po prawej. Trzyma się dolnej krawędzi viewportu i
 * parkuje się na końcu kontentu — dokładnie jak w CLAUDE.md "Sticky save bar".
 *
 * Wzorzec wcześniej kopiowany inline w 13 sekcjach Kreatora.
 */
export function SettingsSaveBar({
  saving,
  status,
  onSave,
  label = 'Zapisz ustawienia',
  successLabel = 'Zapisano',
  errorLabel = 'Błąd zapisu',
  children,
}: SettingsSaveBarProps) {
  return (
    <div className="sticky bottom-0 z-30 -mx-1 px-1 pt-4">
      <div className="flex items-center gap-3 p-4 rounded-xl bg-surface-raised/95 backdrop-blur-sm border border-border shadow-lg">
        <button
          onClick={onSave}
          disabled={saving}
          className="btn-primary text-sm flex items-center gap-1.5 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />}
          {label}
        </button>
        {status === 'success' && (
          <span className="flex items-center gap-1.5 text-xs text-success animate-fade-in">
            <CheckCircle className="w-3.5 h-3.5" /> {successLabel}
          </span>
        )}
        {status === 'error' && (
          <span className="flex items-center gap-1.5 text-xs text-danger animate-fade-in">
            <AlertCircle className="w-3.5 h-3.5" /> {errorLabel}
          </span>
        )}
        {children}
      </div>
    </div>
  );
}
